import React from 'react'
import PropTypes from 'prop-types'
import TextLink from 'portal-modules/common/components/TextLink'
import { ModalControl } from '@entrata/portals-common/lib/components'
import { RequestContentModal } from 'portal-modules/common/components/modals'
import { AUTH } from '../constants/urls'
import { getTerms } from 'portal-modules/terms/api'
import { connect } from 'react-redux'

import styled from '@emotion/styled'
import { css } from '@emotion/core'

import {
  FocusSpan,
  underlineFocus,
} from 'portal-modules/common/components/focus-styles'
import PrivacyPolicy from 'portal-modules/common/components/PrivacyPolicy'

const StyledFooter = styled('footer')`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  margin-top: 16px;
  padding: 0;
  text-align: center;
`

const StyledTextLink = styled(TextLink)`
  font-size: 14px;
  color: ${({ theme }) => theme.blue.system_blue};

  span {
    pointer-events: visible;
  }

  &:not(:first-child) {
    margin-left: 16px;
    position: relative;

    &::before {
      content: '';
      width: 1px;
      height: 16px;
      background: ${({ theme }) => theme.secondary.light};
      pointer-events: none;
      position: absolute;
      top: 50%;
      left: -8px;
      transform: translateY(-50%);
      pointer-events: none;
    }
  }

  &:last-child {
    margin-left: 16px;
  }

  ${underlineFocus}
`

const StyledButton = styled('button')`
  cursor: pointer;
  background: none;
  border: none;
  color: ${({ theme }) => theme.blue.system_blue};
  display: inline-block;
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 11px;
  padding: 0;

  &:first-child {
    margin-right: 8px;
    position: relative;

    &::after {
      content: '';
      width: 1px;
      height: 12px;
      background: ${({ theme }) => theme.secondary.base};
      pointer-events: none;
      position: absolute;
      top: 50%;
      right: -8px;
      transform: translateY(-50%);
    }
  }

  &:last-child {
    margin-left: 8px;
  }

  ${underlineFocus}
`

const StyledCopyRightP = styled('p')`
  color: ${({ theme }) => theme.text.dark};
  font-size: 7px;
  text-align: center;
`
const CurrentDate = new Date()
const CopyrightYear = `${CurrentDate.getFullYear()}`

const LoginFormLinks = ({ propertyCount }) => (
  <StyledFooter>
    <div
      css={css`
        margin-bottom: 16px;
      `}
    >
      {window.rpSettings.projectName === 'rp' && (
        <StyledTextLink
          to={propertyCount > 1 ? AUTH.SIGNUP_PROPERTY_SELECTION : AUTH.SIGNUP}
        >
          {__('Need to Sign Up?')}
        </StyledTextLink>
      )}
      <StyledTextLink to={AUTH.RESET_PASSWORD}>
        {__('Forgot Password?')}
      </StyledTextLink>
    </div>
    <div>
      <div>
        <ModalControl>
          {({ onClick, ref, ...modalProps }) => (
            <>
              <StyledButton onClick={onClick} ref={ref}>
                <FocusSpan>{__('Terms of Use')}</FocusSpan>
              </StyledButton>
              <RequestContentModal
                {...modalProps}
                title={__('Terms & Conditions')}
                requestContent={getTerms}
                isTermsPage={true}
              />
            </>
          )}
        </ModalControl>
        <PrivacyPolicy current_page='login' />
      </div>
      <StyledCopyRightP>
        {window?.__LOCALE_DATA__?.country &&
          window?.__LOCALE_DATA__?.country === 'CN' &&
          window.rpSettings.ICPLicenseNumber &&
          __('ICP License: ') +
            window.rpSettings.ICPLicenseNumber +
            '  |  '}{' '}
        {__('©')}
        {CopyrightYear}
        {__('{%s, 0}. All rights reserved.', [' Entrata, Inc'])}
      </StyledCopyRightP>
    </div>
  </StyledFooter>
)

LoginFormLinks.propTypes = {
  propertyCount: PropTypes.number,
}

export default connect(({ clientProperties }) => ({
  propertyCount: clientProperties && clientProperties.length,
}))(LoginFormLinks)
